import { SlateNode } from '@src/components/sco/RichMarkdownInput'
import { EditorElementTypes } from '@src/components/sco/RichMarkdownInput/components/Element'

/** `raw_markdown` nodes (see utilities/markdown.tsx) are void; inline ones sit in the text. */
export function withRawMarkdown(editor, options: any = {}) {
  const { isInline, isVoid } = editor

  editor.isVoid = (element: SlateNode) =>
    element.type === EditorElementTypes.RAW_MARKDOWN ? true : isVoid(element)

  editor.isInline = (element: SlateNode & { inline?: boolean }) =>
    element.type === EditorElementTypes.RAW_MARKDOWN ? !!element.inline : isInline(element)

  return editor
}
